var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivitieBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7566 14.4H3.25664C3.01795 14.4 2.78903 14.4948 2.62024 14.6636C2.45146 14.8324 2.35664 15.0613 2.35664 15.3C2.35664 15.5387 2.45146 15.7676 2.62024 15.9364C2.78903 16.1052 3.01795 16.2 3.25664 16.2H16.7566V18H3.25664C2.54056 18 1.8538 17.7155 1.34745 17.2092C0.841104 16.7028 0.556641 16.0161 0.556641 15.3V1.8C0.556641 1.32261 0.746283 0.864773 1.08385 0.527208C1.42141 0.189642 1.87925 0 2.35664 0H16.7566V14.4ZM2.35664 12.645C2.50244 12.6153 2.65274 12.6 2.80664 12.6H14.9566V1.8H2.35664V12.645ZM12.2566 6.3H5.05664V4.5H12.2566V6.3Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitieBooks);
export default __webpack_public_path__ + "static/media/activitie-books.b80aea1041bd5403dc3481ede3001a5b.svg";
export { ForwardRef as ReactComponent };